import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "lg:container lg:mx-auto pt-24 md:pt-16" }
const _hoisted_2 = { class: "px-4 lg:px-0" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h3", { class: "mb-2" }, "My Investments", -1)
const _hoisted_4 = {
  key: 0,
  class: "px-4 lg:px-0"
}
const _hoisted_5 = { class: "text-black-600" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "mb-16" }, null, -1)
const _hoisted_7 = { class: "px-4 lg:px-0" }
const _hoisted_8 = /*#__PURE__*/_createVNode("h3", { class: "mb-3" }, "Beethoven-X Investment Pools", -1)
const _hoisted_9 = { class: "px-4 lg:px-0 mb-3 flex" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, [
  /*#__PURE__*/_createVNode("h3", null, "Community Investment Pools"),
  /*#__PURE__*/_createVNode("p", null, " Investment pools created by the community. Please DYOR before investing in any community pool. ")
], -1)
const _hoisted_11 = {
  key: 1,
  class: "px-4 lg:px-0"
}
const _hoisted_12 = { class: "text-black-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalAlert = _resolveComponent("BalAlert")
  const _component_PoolsTable = _resolveComponent("PoolsTable")
  const _component_BalLink = _resolveComponent("BalLink")
  const _component_TokenSearchInput = _resolveComponent("TokenSearchInput")
  const _component_BalBtn = _resolveComponent("BalBtn")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isWalletReady && _ctx.userPools && _ctx.userPools.length > 0)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("div", _hoisted_2, [
            _hoisted_3,
            (_ctx.hasUnstakedBpt)
              ? (_openBlock(), _createBlock(_component_BalAlert, {
                  key: 0,
                  title: "You have unstaked BPT in your wallet",
                  description: "If you deposit your BPT into the farm, you will earn additional rewards paid out in BEETS.",
                  type: "warning",
                  size: "sm",
                  class: ""
                }))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_PoolsTable, {
            isLoading: _ctx.isLoadingUserPools,
            data: _ctx.userPools,
            noPoolsLabel: _ctx.$t('noInvestments'),
            showPoolShares: "",
            class: "mb-8"
          }, null, 8, ["isLoading", "data", "noPoolsLabel"]),
          (!_ctx.hideV1Links)
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('seeV1BalancerInvestments')), 1),
                _createVNode(_component_BalLink, {
                  href: _ctx.EXTERNAL_LINKS.Balancer.PoolsV1Dashboard,
                  external: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('goToBalancerV1Site')), 1)
                  ]),
                  _: 1
                }, 8, ["href"])
              ]))
            : _createCommentVNode("", true),
          _hoisted_6
        ], 64))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_7, [
      _hoisted_8,
      _createVNode(_component_TokenSearchInput, {
        modelValue: _ctx.selectedTokens,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedTokens = $event)),
        loading: _ctx.isLoadingPools,
        onAdd: _ctx.addSelectedToken,
        onRemove: _ctx.removeSelectedToken
      }, null, 8, ["modelValue", "loading", "onAdd", "onRemove"])
    ]),
    _createVNode(_component_PoolsTable, {
      isLoading: _ctx.isLoadingPools,
      data: _ctx.filteredPools,
      noPoolsLabel: _ctx.$t('noPoolsFound'),
      isPaginated: _ctx.poolsHasNextPage,
      isLoadingMore: _ctx.poolsIsFetchingNextPage,
      onLoadMore: _ctx.loadMorePools,
      class: "mb-16"
    }, null, 8, ["isLoading", "data", "noPoolsLabel", "isPaginated", "isLoadingMore", "onLoadMore"]),
    _createVNode("div", _hoisted_9, [
      _hoisted_10,
      _createVNode(_component_BalBtn, {
        label: "Compose a pool",
        onClick: _ctx.goToPoolCreate
      }, null, 8, ["onClick"])
    ]),
    _createVNode(_component_PoolsTable, {
      isLoading: _ctx.isLoadingPools,
      data: _ctx.communityPools,
      noPoolsLabel: _ctx.$t('noPoolsFound'),
      isPaginated: _ctx.poolsHasNextPage,
      isLoadingMore: _ctx.poolsIsFetchingNextPage,
      onLoadMore: _ctx.loadMorePools,
      class: "mb-8"
    }, null, 8, ["isLoading", "data", "noPoolsLabel", "isPaginated", "isLoadingMore", "onLoadMore"]),
    (!_ctx.hideV1Links)
      ? (_openBlock(), _createBlock("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('tableShowsBalancerV2Pools')), 1),
          _createVNode(_component_BalLink, {
            href: _ctx.EXTERNAL_LINKS.Balancer.PoolsV1Explore,
            external: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('exploreBalancerV1Pools')), 1)
            ]),
            _: 1
          }, 8, ["href"])
        ]))
      : _createCommentVNode("", true)
  ]))
}